import { ColumnActionsMode, IDetailsColumnStyles } from '@fluentui/react';
import { ColumnData } from 'common/components/SearchBar';
import useGetScreenWidth from 'common/hooks/useGetScreenWidth';
import {
  rightAlignHeaderStyle,
  commonDocumentColumnProps as commonColumnProps,
} from 'common/utils/columnUtilities';

const colHeaderLeftAlignStyle: Partial<IDetailsColumnStyles> = {
  cellTitle: {
    marginLeft: 20,
  },
};

const useColumns = () => {
  const { isSm, isLg } = useGetScreenWidth();

  const columns: ColumnData[] = [
    {
      key: 'documentType',
      name: 'Type',
      fieldName: 'documentType',
      minWidth: 220,
      maxWidth: 220,
      styles: colHeaderLeftAlignStyle,
      ...commonColumnProps,
    },
    {
      key: '_documentPoolName',
      name: 'Folder',
      fieldName: '_documentPoolName',
      minWidth: 120,
      maxWidth: 120,
      ...commonColumnProps,
      isVisible: false,
    },
    {
      key: 'indexName',
      name: 'Name',
      fieldName: 'indexName',
      minWidth: 150,
      maxWidth: 150,
      ...commonColumnProps,
    },
    {
      key: 'indexReferenceNumber',
      name: 'Number',
      fieldName: 'indexReferenceNumber',
      minWidth: 120,
      maxWidth: 120,
      ...commonColumnProps,
    },
    {
      key: 'indexTransactionDate',
      name: 'Date',
      fieldName: 'indexTransactionDate',
      minWidth: 80,
      maxWidth: 80,
      ...commonColumnProps,
    },
    {
      key: 'businessUnitName',
      name: 'Business Unit',
      fieldName: 'businessUnitName',
      minWidth: 90,
      maxWidth: 90,
      ...commonColumnProps,
      columnActionsMode: ColumnActionsMode.disabled,
      isVisible: false,
    },
    {
      key: 'departmentName',
      name: 'Department',
      fieldName: 'departmentName',
      minWidth: 80,
      maxWidth: 80,
      ...commonColumnProps,
      columnActionsMode: ColumnActionsMode.disabled,
      isVisible: false,
    },
    {
      key: '_documentContents',
      name: 'Contents',
      fieldName: '_documentContents',
      minWidth: 200,
      maxWidth: 200,
      ...commonColumnProps,
      isVisible: !isSm,
    },
    {
      key: 'comment',
      name: 'Comments',
      fieldName: 'comment',
      minWidth: 120,
      maxWidth: 120,
      isResizable: true,
      ...commonColumnProps,
      isVisible: isLg,
    },
    {
      key: 'indexAmount',
      name: 'Total',
      fieldName: 'indexAmount',
      minWidth: 70,
      maxWidth: 70,
      ...commonColumnProps,
      styles: rightAlignHeaderStyle,
    },
    {
      key: 'isoCode',
      name: 'Currency',
      fieldName: 'isoCode',
      minWidth: 65,
      maxWidth: 65,
      ...commonColumnProps,
      isVisible: isLg,
    },
    {
      key: 'view',
      name: '',
      fieldName: '',
      minWidth: 20,
      maxWidth: 20,
      ...commonColumnProps,
      toggleVisibility: false,
      isResizable: false,
    },
    {
      key: 'download',
      name: '',
      fieldName: '',
      minWidth: 20,
      maxWidth: 20,
      ...commonColumnProps,
      toggleVisibility: false,
      isResizable: false,
    },
    {
      key: 'fileReference',
      name: 'Documents',
      fieldName: 'fileReference',
      minWidth: 150,
      maxWidth: 150,
      isResizable: true,
      ...commonColumnProps,
      isVisible: isLg,
    },
    {
      key: '_createdDate',
      name: 'Created On',
      fieldName: '_createdDate',
      minWidth: 150,
      maxWidth: 150,
      ...commonColumnProps,
      isVisible: isLg,
    },
    {
      key: '_exportDate',
      name: 'Exported On',
      fieldName: '_exportDate',
      minWidth: 150,
      maxWidth: 150,
      ...commonColumnProps,
      isVisible: isLg,
    },
    {
      key: '_exportedByUser',
      name: 'Exported By',
      fieldName: '_exportedByUser',
      minWidth: 150,
      maxWidth: 150,
      ...commonColumnProps,
      isVisible: false,
    },
  ];
  return { columns };
};
export { useColumns };
